export { AddressAutocomplete } from '@/components/address/AddressAutocomplete';
export type { AddressAutocompleteProps } from '@/components/address/AddressAutocomplete';
